module.exports = global["$"] = require("-!D:\\a\\1\\s\\Beckshop.Umbraco.Website.V11\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");